import { ArticleCard } from './ArticleCard'
import { Container } from '@/components/shared/Container'
import styled from 'styled-components'

const StyledCategoryHeader = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: 16px;
  margin-bottom: 32px;
  border-bottom: 1px solid ${(props) => props.theme.v2.onSurface.subdued.border};

  h2 {
    margin: 0;
    font-size: 40px;
    font-family: ${(props) => props.theme.v2.font.nantes};
    line-height: 54px;
  }

  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    h2 {
      font-size: 32px;
      line-height: 48px;
    }
  }

  @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    h2 {
      font-size: 24px;
      line-height: 32px;
    }
  }
`

const StyledArticleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  grid-column-gap: 32px;
  grid-row-gap: 40px;
  margin-bottom: 80px;

  .feat-1 {
    grid-area: 1 / 1 / 3 / 3;
  }
  .feat-2 {
    grid-area: 1 / 3 / 2 / 4;
  }
  .feat-3 {
    grid-area: 2 / 3 / 3 / 4;
  }
  .feat-4 {
    grid-area: 3 / 1 / 4 / 2;
  }
  .feat-5 {
    grid-area: 3 / 2 / 4 / 3;
  }
  .feat-6 {
    grid-area: 3 / 3 / 4 / 4;
  }

  & div.mobile {
    display: none !important;
  }

  & div.desktop {
    display: block !important;
  }

  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(4, 1fr);
    gap: 24px 24px;
    margin-bottom: 60px;

    div {
      &.feat-1 {
        grid-area: 1 / 1 / 2 / 3;
      }
      &.feat-2 {
        grid-area: 2 / 1 / 3 / 2;
      }
      &.feat-3 {
        grid-area: 2 / 2 / 3 / 3;
      }
      &.feat-4 {
        grid-area: 3 / 1 / 4 / 3;
      }
      &.feat-5 {
        grid-area: 4 / 1 / 5 / 2;
      }
      &.feat-6 {
        grid-area: 4 / 2 / 5 / 3;
      }
    }

    & div.mobile {
      display: block !important;
    }

    & div.desktop {
      display: none !important;
    }
  }
`

type LatestFeaturedArticleProps = {
  featuredArticles: any
}

export const LatestFeaturedArticles = ({ featuredArticles }: LatestFeaturedArticleProps) => {
  return (
    <Container>
      <StyledCategoryHeader>
        <h2>Featured</h2>
      </StyledCategoryHeader>
      <StyledArticleGrid>
        {featuredArticles
          .sort((a, b) => b.firstFeaturedArticle - a.firstFeaturedArticle)
          .map((article, idx) => (
            <ArticleCard
              key={article.id}
              article={article}
              className={`feat-${idx + 1}`}
              firstFeatured={article.firstFeaturedArticle}
            />
          ))}
      </StyledArticleGrid>
    </Container>
  )
}
